<script>
import CockpitMatryoshkaColumnQueueItem
from '@/components/cockpit/matryoshka/CockpitMatryoshkaColumnQueueItem.vue';
import { mapActions, mapGetters } from 'vuex';
import MatrioshkaVisualizationColumn from '../visualization/MatrioshkaVisualizationColumn.vue';
import loopRequest from '../../../../core/mixins/loopRequest';

export default {
  name: 'CockpitMatryoshkaColumn',
  props: {
    loading: Boolean,
    title: String,
    unit: Object,
    activeOrder: Object,
    orderInstance: Object,
    debugStatuses: Array,
    labelArchive: Array,
    palletsColumn: Boolean,
    openPalletItemsCount: Number,
  },
  data: () => ({
    showLabelPrintSelectModal: false,
    loadingLineLabelingPoints: false,
    lineLabelingPoints: [],
    lastPrintRequest: null,
    lastPrintRequestFetched: false,
  }),
  components: {
    CockpitMatryoshkaColumnQueueItem,
    MatrioshkaVisualizationColumn,
  },
  mixins: [
    loopRequest('getLastPrintRequest', 5000),
  ],
  computed: {
    ...mapGetters([
      'globalSettings',
    ]),
    ...mapGetters('packingSettings', [
      'getHigherLevelUnit',
      'getLowerLevelUnit',
      'getUnitToUnitRelation',
    ]),
    ...mapGetters('emptyLabelArchive', [
      'isLabelArchiveEmpty',
    ]),
    ...mapGetters('debug', ['debug']),
    lineId() {
      return this.activeOrder.order.lineId;
    },
    lowerLevelUnit() {
      return this.getLowerLevelUnit(
        this.unit.id,
        this.activeOrder.order.skuId,
      );
    },
    higherLevelUnit() {
      return this.getHigherLevelUnit(
        this.unit.id,
        this.activeOrder.order.skuId,
      );
    },
    isHigherLevelUnitLast() {
      if (!this.higherLevelUnit) return false;

      return !this.getHigherLevelUnit(
        this.higherLevelUnit.id,
        this.activeOrder.order.skuId,
      );
    },
    labelingPointId() {
      return this.orderInstance?.labelingPointId || null;
    },
    noOrderInstanceForColumn() {
      return !this.orderInstance;
    },
    isLastPrintRequestCompleted() {
      return this.lastPrintRequest?.requestStatus !== 'FAILED';
    },
    isLastUnit() {
      return Boolean(this.lowerLevelUnit && !this.higherLevelUnit);
    },
    filteredLabelArchive() {
      return [...this.labelArchive]
        .filter(x => x.unitId === this.unit.id)
        // .filter(x => {
        //   let show = x.labelStatus === 'Active' || this.palletsColumn;

      //   // const lowerLevelUnit = this.getLowerLevelUnit(x.unitId, x.skuId);
      //   const higherLevelUnit = this.getHigherLevelUnit(x.unitId, x.skuId);
      //   // const lowerLevelChildrenRelations = x.containedLabels?.filter(y => y.unitId === lowerLevelUnit?.id);
      //   const higherLevelParentRelations = x.containers?.filter(y => y.containerUnitId === higherLevelUnit?.id);

      //   if (this.isHigherLevelUnitLast) {
      //     const parents = higherLevelParentRelations.map(y => this.labelArchive.find(z => z.id === y.containerId));
      //     show = show && parents.every(y => y.labelStatus !== 'Active');
      //   } else {
      //     show = show && higherLevelParentRelations.length === 0;
      //   }

      //   // if (lowerLevelUnit) {
      //   //   show = show && x.labelStatus === 'Active';
      //   // }

      //   // if (lowerLevelUnit
      //   // && lowerLevelChildrenRelations
      //   //   .filter(y => !this.isLabelArchiveEmpty(y.id)).length === 0) {
      //   //   show = show && false;
      //   // }

      //   // if (higherLevelUnit) {
      //   //   // show = show && higherLevelParentRelations.length > 0;
      //   //   const parents = higherLevelParentRelations
      //   // .map(y => this.labelArchive.find(z => z?.id === y.containerId));
      //   //   show = show && parents.every(y => {
      //   //     const archiveItem = this.labelArchive.find(z => z?.id === y?.id);
      //   //     return archiveItem?.labelStatus !== 'Active';
      //   //   });
      //   //   show = show && (higherLevelParentRelations || []).every(y => {
      //   //     const innerParent = this.labelArchive.find(z => z?.id === y?.containerId);
      //   //     const innerParentThisLevelChildren = (innerParent?.containedLabels || [])
      //   //       .filter(l => l?.unitId === y?.unitId)
      //   //       .filter(l => !this.isLabelArchiveEmpty(l?.id));
      //   //     const unitToUnitRelation = this.getUnitToUnitRelation(
      //   //       y?.unitId,
      //   //       y?.containerUnitId,
      //   //       x?.skuId,
      //   //     );
      //   //     return innerParentThisLevelChildren.length < unitToUnitRelation.amount;
      //   //   });

      //   //   if (parents.length > 0) {
      //   //     const parent = parents[0];
      //   //     const isNextLevelEndUnit = !this.getHigherLevelUnit(parent?.unitId, x?.skuId);

      //   //     if (isNextLevelEndUnit) {
      //   //       show = show && false;
      //   //     }
      //   //   }
      //   // }

        //   return show;
        // })
        .reverse()
        .sort((a, b) => {
          if (a.labelStatus === 'Active' && b.labelStatus !== 'Active') return 1;
          if (a.labelStatus !== 'Active' && b.labelStatus === 'Active') return -1;
          return (b.scanIndex || -1) - (a.scanIndex || -1);
        });
    },
    isMiddleUnit() {
      return this.higherLevelUnit && this.lowerLevelUnit;
    },
    queueLength() {
      if (this.palletsColumn) {
        return this.labelArchive.filter(x => x.unitId === this.unit.id).length;
      }

      return this.filteredLabelArchive.length || 0;
    },
    maxChildren() {
      const lowerUnit = this.getLowerLevelUnit(this.unit.id, this.activeOrder.order.skuId);
      if (!lowerUnit) return '';
      const relation = this.getUnitToUnitRelation(
        lowerUnit.id,
        this.unit.id,
        this.activeOrder.order.skuId,
      );

      return relation.amount || 0;
    },
    amountLowerUnitInEndUnit() {
      if (!this.palletsColumn) return 0;

      const lowerUnit = this.getLowerLevelUnit(this.unit.id, this.activeOrder.order.skuId);
      const relation = this.getUnitToUnitRelation(
        lowerUnit.id,
        this.unit.id,
        this.activeOrder.order.skuId,
      );

      return relation.amount;
    },
  },
  emits: [
    'select-item',
    'manual-aggregation',
    'show-print-batch',
  ],
  watch: {
    showLabelPrintSelectModal(value) {
      if (!value) {
        this.lineLabelingPoints = [];
      } else {
        this.fetchLineLabelingPoints();
      }
    },
  },
  methods: {
    ...mapActions([
      'getLineLabelingPoint',
      'getRequests',
    ]),
    async getLastPrintRequest() {
      if (!this.labelingPointId) return;
      if (this.palletsColumn) return;

      const { data } = await this.getRequests({
        params: {
          query: {
            types: ['Print'],
            page: 0,
            count: 1,
            labellingPointIds: [this.labelingPointId],
          },
        },
      });

      this.lastPrintRequest = data?.items?.[0] || null;
      this.lastPrintRequestFetched = true;
    },
    async openPrintBatchModal() {
      await this.fetchLineLabelingPoints();

      const labelingPoint = this.lineLabelingPoints.find(lp => lp.unitId === this.unit.id);
      if (!labelingPoint) return;

      this.$emit('show-print-batch', {
        lineId: this.lineId,
        activeOrder: this.activeOrder,
        unit: this.unit,
        amountLowerUnitInEndUnit: this.maxChildren,
        labelingPoint,
      });
    },
    openLabelPrintSelectModal() {
      this.showLabelPrintSelectModal = true;
    },
    async fetchLineLabelingPoints() {
      this.loadingLineLabelingPoints = true;
      const { data } = await this.getLineLabelingPoint({
        params: {
          plantCode: this.globalSettings.plantCode,
          lineId: this.lineId,
        },
      });
      this.lineLabelingPoints = data;
      this.loadingLineLabelingPoints = false;
    },
    goToManualAggregation(labelingPoint) {
      this.$router.push(`/manual-aggregation/${this.lineId}/${labelingPoint.id}/${this.unit.id}`);
    },
  },
};
</script>

<template>
  <div
    class="column"
    :class="{ 'failed-print-request': lastPrintRequestFetched && !isLastPrintRequestCompleted }"
  >
    <div
      v-if="lastPrintRequestFetched && !isLastPrintRequestCompleted"
      class="p-3 d-flex failed-print-request"
      style="gap: 1rem"
    >
      <i class="fas fa-exclamation-triangle h2 mb-0" />
      <p class="mb-0">
        Ostatnie żądanie drukowania zakończone niepowodzeniem.
      </p>
    </div>
    <div
      v-if="noOrderInstanceForColumn"
      class="no-instance"
    >
      <i class="fas fa-exclamation-triangle h1" />
      <p class="h3 mb-1">
        {{ title }}
      </p>
      <p class="text-center mb-0">
        Zlecenie nie jest poprawnie uzbrojone na ten poziom znakowania
      </p>
    </div>
    <div class="column-title">
      <span>
        <i
          v-if="palletsColumn"
          class="fas fa-grip-dots mr-1"
        />
        <i
          v-else-if="isMiddleUnit"
          class="fas fa-ellipsis mr-1"
        />
        <i
          v-else
          class="fas fa-period mr-1"
          style="transform: translateY(-5px);"
        />

        {{ title }}
      </span>

      <!-- TODO: add manual aggregation button back when it's implemented -->
      <div
        v-if="lowerLevelUnit && higherLevelUnit && false"
        class="manual-aggregation-button"
        @click.stop="openLabelPrintSelectModal()"
      >
        <i class="fas fa-box-open" />
        Agreguj manualnie
      </div>

      <div
        v-if="higherLevelUnit"
        class="manual-aggregation-button"
        @click.stop="openPrintBatchModal()"
      >
        <i class="fas fa-print" />
        Drukuj manualnie
      </div>
    </div>

    <div class="line" />

    <MatrioshkaVisualizationColumn
      v-if="debug"
      :label-archive="labelArchive"
      :unit-id="unit.id"
      :debug-statuses="debugStatuses"
      @select-item="$emit('select-item', $event)"
    />

    <div
      v-if="!debug"
      class="column-queue-length"
    >
      <Loader v-if="loading" />
      <span v-else>
        {{ queueLength }}
      </span>
    </div>

    <div
      v-if="!debug"
      class="line"
    />

    <div
      v-if="!debug"
      class="queue-heading"
    >
      <span v-if="!palletsColumn">
        {{ $t('cockpit.queue') }}
      </span>

      <div
        v-if="false"
        class="clear-queue-button"
      >
        {{ $t('cockpit.clearQueue') }}
      </div>
    </div>

    <Loader v-if="loading" />
    <div
      v-else-if="!debug"
      class="queue-list-wrapper"
    >
      <CockpitMatryoshkaColumnQueueItem
        v-for="labelArchiveItem in filteredLabelArchive"
        :key="labelArchiveItem.id"
        :item="labelArchiveItem"
        :pallets-column="palletsColumn"
        @select-item="$emit('select-item', $event)"
      />

      <p
        v-if="filteredLabelArchive.length === 0 && !openPalletItemsCount"
        class="text-center text-black-50 p-3 mb-0 small"
      >
        Kolejka jest pusta
      </p>
    </div>

    <BModal
      v-model="showLabelPrintSelectModal"
      title="Wybierz punkt etykietowania"
      hide-footer
    >
      <div
        v-for="point in lineLabelingPoints"
        :key="point.id"
        class="labeling-point-button"
        @click="openPrintBatchModal(point)"
      >
        <i class="fas fa-print mr-3" />

        <div>
          <p>
            {{ point.name }}
            <BBadge>
              {{ point.type }}
            </BBadge>
          </p>
          <p>
            {{ point.description }}
          </p>
        </div>

        <i class="fas fa-chevron-right ml-auto" />
      </div>
    </BModal>
  </div>
</template>

<style scoped lang="scss">
@import "~@/styles/vars.icss";

.open-pallet {
  border-radius: 6px;
  padding: 4px 8px;
  background-color: white;
  border: 1px solid #F0F1F3;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.column {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 250px;
  min-height: -webkit-fill-available;
  max-height: max-content;
  background-color: white;
  border-radius: 9px;
  padding: 16px;
  position: relative;

  &.failed-print-request {
    margin-top: 5.5rem;
  }

  .no-instance {
    background-color: rgba(255, 232, 232, 0.96);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #700000;
    padding: 16px;
    border-radius: 9px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }

  .failed-print-request {
    background-color: rgba(255, 232, 232, 0.96);
    color: #700000;
    border-radius: 9px;
    position: absolute;
    left: 0;
    top: -5.5rem;
    width: 100%;
    align-items: center;

    p {
      font-size: 14px;
    }
  }

  .line {
    border-bottom: 1px solid #F0F1F3;
  }

  .column-title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 12px;
    padding-left: 1px;
  }

  .column-queue-length {
    font-size: 61px;
    line-height: 90px;
    font-weight: 500;
    text-align: center;
    margin-top: 0.5rem;
  }

  .manual-aggregation-button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 24px;
    background-color: #EFEFEF;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    border-radius: 30px;
    width: 144px;
    color: #7F7F7F;

    &:hover {
      background-color: #E0E0E0;
    }

    i {
      margin-right: 5px;
    }
  }

  .queue-heading {
    font-size: 14px;
    font-weight: 500;
    color: black;
    padding: 0.75rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .clear-queue-button {
      color: #7CB92D;
      font-weight: 400;
      font-size: 11px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .queue-list-wrapper {
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 4px;
    padding-right: 4px;
  }
}

.labeling-point-button {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #F0F1F3;
  cursor: pointer;

  &:hover {
    background-color: #F0F1F3;
  }

  &:last-child {
    border-bottom: none;
  }

  i {
    font-size: 20px;
    margin-right: 10px;
  }

  p {
    margin: 0;
  }

  p:first-child {
    font-size: 14px;
    font-weight: 500;
  }

  p:last-child {
    font-size: 12px;
    color: #7E7E7E;
  }
}
</style>
